import { Project } from "../types/dashboard.types";
import { usePageBuilderMeQuery } from "../../workspace/hooks/usePageBuilderMeQuery";
import { useGetMyDraftsQuery } from "../../drafts/hooks/useMyDraftsQuery";
import { mergeProjects, toProjectFromDrafts, toProjectFromSites } from "../helpers/normalize-project";

export function useDashboardProjects() {
  const query = usePageBuilderMeQuery();
  const draftsQuery = useGetMyDraftsQuery();

  const projects: Project[] = (() => {
    const normalizedDrafts = (draftsQuery?.data ?? []).map(toProjectFromDrafts);
    const normalizedSites = (query.data?.data ?? []).map(toProjectFromSites);
    return mergeProjects(normalizedDrafts, normalizedSites);
  })();


  return {
    projects,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    error: query.error ? (query.error as Error).message : null,
    refetch: query.refetch,
  };
}
